// Chakra imports
import React, { useState } from "react";
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  useColorModeValue,
  Select,
} from "@chakra-ui/react";
import signInImage from "assets/img/zana-console.png";
import { useHistory } from "react-router-dom";

function SignUp() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [selectedEndpoint, setSelectedEndpoint] = useState("");

  const history = useHistory();

  const titleColor = useColorModeValue("purple.500", "purple.200");
  const textColor = useColorModeValue("gray.400", "white");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedEndpoint) {
      setError("Please select a server");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    // Here you would typically make an API call to register the user
    console.log("Sign up data:", formData);
    
    // For now, just show a success message or redirect
    setError("Registration functionality will be implemented");
  };

  return (
    <Flex position="relative" mb="40px">
      <Flex
        h={{ sm: "initial", md: "75vh", lg: "85vh" }}
        w="100%"
        maxW="1044px"
        mx="auto"
        justifyContent="space-between"
        mb="30px"
        pt={{ sm: "100px", md: "0px" }}
      >
        <Flex
          alignItems="center"
          justifyContent="start"
          style={{ userSelect: "none" }}
          w={{ base: "100%", md: "50%", lg: "42%" }}
        >
          <Flex
            direction="column"
            w="100%"
            background="transparent"
            p="48px"
            mt={{ md: "150px", lg: "80px" }}
          >
            <Heading color={titleColor} fontSize="32px" mb="30px">
              {"Create Account"}
            </Heading>
        
            <FormControl>
              <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                {"Full Name"}
              </FormLabel>
              <Input
                borderRadius="15px"
                mb="24px"
                fontSize="sm"
                type="text"
                placeholder="Your full name"
                size="lg"
                onChange={handleChange}
                name="name"
                value={formData.name}
              />
              <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                {"Password"}
              </FormLabel>
              <Input
                borderRadius="15px"
                mb="24px"
                fontSize="sm"
                type="password"
                placeholder="Your password"
                size="lg"
                onChange={handleChange}
                name="password"
                value={formData.password}
              />
              <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                {"Confirm Password"}
              </FormLabel>
              <Input
                borderRadius="15px"
                mb="36px"
                fontSize="sm"
                type="password"
                placeholder="Confirm your password"
                size="lg"
                onChange={handleChange}
                name="confirmPassword"
                value={formData.confirmPassword}
              />
              <Flex
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                maxW="100%"
                mt="0px"
              >
                <Text color="red" marginTop="10px" fontWeight="medium">
                  {error}
                </Text>
              </Flex>
              <Button
                onClick={handleSubmit}
                fontSize="16px"
                type="submit"
                bg="purple.500"
                w="100%"
                h="45"
                mb="20px"
                color="white"
                mt="20px"
                _hover={{ bg: "purple.200" }}
                _active={{ bg: "purple.400" }}
              >
                {"Sign Up"}
              </Button>
            </FormControl>
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              maxW="100%"
              mt="0px"
            >
              <Text color={textColor} fontWeight="medium">
                {"Already have an account?"}
                <Text
                  as="span"
                  color={titleColor}
                  ms="5px"
                  fontWeight="bold"
                  cursor="pointer"
                  onClick={() => history.push("/auth/signin")}
                  _hover={{ textDecoration: "underline" }}
                >
                  {"Sign In"}
                </Text>
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Box
          display={{ base: "none", md: "block" }}
          overflowX="hidden"
          h="100%"
          w="40vw"
          position="absolute"
          right="0px"
        >
          <Box
            bgImage={signInImage}
            w="100%"
            h="100%"
            bgSize="cover"
            bgPosition="50%"
            position="absolute"
            borderBottomLeftRadius="20px"
          ></Box>
        </Box>
      </Flex>
    </Flex>
  );
}

export default SignUp;
